import React from 'react';
import PropTypes from 'prop-types';
import { Table } from '@statsbomb/kitbag-components';

export function CellHeadings({ cells, textAlign }) {
  return (
    <Table.Head>
      <Table.Row>
        {cells.map((cell) => (
          <Table.HeaderCell
            colSpan={cell.colSpan}
            key={`cell-heading-${cell.id}`}
            textAlign={cell.align || textAlign}
          >
            {cell.children}
          </Table.HeaderCell>
        ))}
      </Table.Row>
    </Table.Head>
  );
}

CellHeadings.propTypes = {
  cells: PropTypes.arrayOf(
    PropTypes.shape({
      align: PropTypes.string,
      children: PropTypes.node.isRequired,
      id: PropTypes.string.isRequired,
    }),
  ).isRequired,
  textAlign: PropTypes.string,
};

CellHeadings.defaultProps = {
  textAlign: 'center',
};

export default { CellHeadings };
